/* istanbul ignore file */
import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing } = theme;

export const input = css`
  flex-shrink: 0;
  position: relative;
  appearance: none;
  width: ${spacing.xl}px;
  height: ${spacing.xl}px;
  margin: ${spacing.base}px;
  border: solid 1px var(--neutral-black-70);
  border-radius: 100%;
  background-color: var(--neutral-white-base);
  cursor: pointer;

  &::after {
    transition: background-color 200ms;
    background-color: var(--neutral-white-base);
    content: '';
    position: absolute;
    left: 3px;
    top: 3px;
    width: ${spacing.md}px;
    height: ${spacing.md}px;
    border: none;
    border-radius: 100%;
  }

  &:checked::after {
    background-color: var(--brand-purple-base);
  }

  &:disabled {
    cursor: default;
    border-color: var(--neutral-black-40);
  }

  &:disabled:checked::after {
    opacity: 50%;
  }

  &:disabled:not(:checked),
  &:disabled:not(:checked)::after {
    border-color: var(--neutral-black-40);
  }
`;
